import { h } from 'preact';
import { Text } from 'preact-i18n';

// Fixed-choice multi-select as Bootstrap pill buttons. Used for the watch's gren /
// øvelsesgruppe / krets lists, whose options come from the mirror (not free text).
function ChipPicker({
    options = [], selected = [], onToggle, emptyLabel,
}) {
    const chosen = Array.isArray(selected) ? selected : [];
    // A selected name that is no longer offered (renamed krets, mirror empty) must stay
    // visible so the user can unselect it.
    const shown = [...options, ...chosen.filter(name => !options.includes(name))];
    return (
        <div class='d-flex flex-wrap gap-1'>
            {shown.length === 0 && <span class='small text-body-secondary'>–</span>}
            {shown.map((name) => {
                const active = chosen.includes(name);
                return (
                    <button
                        key={name}
                        type='button'
                        class={`btn btn-sm rounded-pill ${active ? 'btn-success' : 'btn-outline-secondary'}`}
                        data-name={name}
                        onClick={() => onToggle(name)}
                    >
                        {name}
                    </button>
                );
            })}
            {chosen.length === 0 && shown.length > 0 && (
                <span class='small text-body-secondary align-self-center ms-1'>
                    {emptyLabel || <Text id='terminliste.any'>Any</Text>}
                </span>
            )}
        </div>
    );
}

export default ChipPicker;
